export const TITLE = "title";
export const DESC = "desc";
